import type { ManagerRegistry } from '../../../core/manager-registry';
import type { RadialMenuItem } from '../types';
import { getIcon } from '../../../utils/icon-manager';

export const createMeasureRadialButton = (registry: ManagerRegistry): RadialMenuItem => {
    return {
        id: 'measure',
        label: 'toolbar.measure',
        icon: getIcon('测量'),
        isToggle: true,
        isActive: registry.bottomDock?.isOpen('measure') ?? false,
        onToggle: (next) => {
            const dock = registry.bottomDock;
            if (!dock) {
                console.warn('[RadialToolbar] bottom dock not initialized: measure');
                return;
            }

            if (next) {
                dock.open('measure');
            } else {
                dock.close('measure');
            }

            console.log(`[RadialToolbar] 测量${next ? '已打开' : '已关闭'}`);
        }
    };
};
